import React, { useState } from 'react';

import Grid from '@mui/material/Grid2';

import { BastionFacility, BastionItem } from "@dndModels";

import { makeStyles } from "@utilities/theme_utilities";

import AddButton from "@components/input/buttons/icon_buttons/AddButton";
import BastionItemInput from "@dndComponents/bastion/BastionItemInput";

interface Props {
  bf: BastionFacility;
  items: BastionItem[];
  onChange: (changed: BastionItem[]) => void;
  disabled?: boolean;
}

export default function BastionItemListInput({
  bf,
  items,
  onChange,
  disabled = false,
}: Props) {
  const [expanded_item_id, setExpandedItemID] = useState("");
  const [ping, setPing] = useState(false);

  const useStyles = makeStyles()((theme) => {
    return ({
      root: {
        '&.tableHeader': {
          color: theme.palette.primary.contrastText,
          backgroundColor: theme.palette.secondary.dark,
        },
        '&.alternate': {
          color: theme.palette.primary.contrastText,
          backgroundColor: theme.palette.primary.dark,
        },
      },
    });
  });

  const onAdd = () => {
    const new_item = new BastionItem();
    const new_items = [...items];
    new_items.push(new_item);
    onChange(new_items);
    setExpandedItemID(new_item.true_id);
  }
  
  const { classes, cx } = useStyles();
  return (
    <Grid container spacing={0} direction="row">
      <Grid
        size={{
          xs: 12
        }}>
        <span className="header padded">
          Bastion Items
        </span>
        { !disabled && 
          <AddButton onClick={onAdd} />
        }
      </Grid>
      { items.map((item, key) => {
        return (
          <Grid
            key={item.true_id}
            container
            spacing={0}
            direction="row"
            size={{
              xs: 12
            }}>
            <Grid
              className={cx(classes.root, (key % 2 === 1 ? "alternate clickable" : "clickable" ))}
              onClick={() => {
                setExpandedItemID(item.true_id === expanded_item_id ? "" : item.true_id);
              }}
              size={{
                xs: 12
              }}>
              { item.name.length > 0 ? item.name : "Nameless" }{ item.cost_gold > 0 ? ` (${item.cost_gold}gp)` : "" }
            </Grid>
            { expanded_item_id === item.true_id && 
              <Grid
                size={{
                  xs: 12
                }}>
                <BastionItemInput
                  bf={bf}
                  item={item} 
                  onChange={() => {
                    onChange(items);
                    setPing(!ping);
                  }}
                  onDelete={() => {
                    onChange(items.filter(o => o.true_id !== item.true_id));
                    setExpandedItemID("");
                  }}
                />
              </Grid>
            }
          </Grid>
        );
      })}
    </Grid>
  );
}
